import './index.css';
import App from './App';
import msalInstance from './services/sso';
import { MsalProvider } from '@azure/msal-react';
import reactDom from 'react-dom';

const root = reactDom.createRoot(document.getElementById('root'));

// This is critical to move inProgress from 'handleRedirect' to 'none'
msalInstance.initialize().then(() => {
  root.render(
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  );
});